import { render, staticRenderFns } from "./ReviewExternalPeople.vue?vue&type=template&id=173bc70e"
import script from "./ReviewExternalPeople.vue?vue&type=script&lang=js"
export * from "./ReviewExternalPeople.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports